import { useRuntimeVariables } from 'app-kit'
import { AuthedAxiosRequests, useGeckoAuth } from 'features/auth'
import _ from 'lodash'
import { useMemo } from 'react'
import { DuckDbFeatureFlag } from 'types'

const fetchDuckDbFeatureFlag = _.memoize(
  async (url: string, authorizedAxios: AuthedAxiosRequests) => {
    const body = {
      type: 'forecast-duckdb-feature-flag',
    }
    const response = await authorizedAxios.post(url, body)
    const data = response.data
    return DuckDbFeatureFlag.CreateFromJSON(
      data[0]?.entry ?? {
        id: 'forecast-duckdb-feature-flag',
        type: 'forecast-duckdb-feature-flag',
        data: {
          enabled: false,
          black_list: [],
          white_list: [],
        },
        tags: {},
        index: {},
        generation: -1,
        created_at: '2025-01-21T21:51:01.041111Z',
        updated_at: '2025-02-19T20:57:14.960463Z',
      }
    )
  }
)

export const useFetchDuckDbFeatureFlag = ():
  | Promise<DuckDbFeatureFlag>
  | undefined => {
  const { ROLODEX_URL } = useRuntimeVariables()
  const { authorizedAxios, authorization } = useGeckoAuth()

  const url = `${ROLODEX_URL}/api/v2/entries/load`

  return useMemo(
    () =>
      authorization ? fetchDuckDbFeatureFlag(url, authorizedAxios) : undefined,
    [authorization, url, authorizedAxios]
  )
}
